import { Card, Row, Text } from "@nextui-org/react";
import React from "react";
export var MyAccount = function MyAccount() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    gap: 2
  }, /*#__PURE__*/React.createElement(Text, {
    h1: true
  }, "My Account")), /*#__PURE__*/React.createElement(Card, {
    color: "warning"
  }, /*#__PURE__*/React.createElement(Text, {
    h2: true
  }, "Sorry"), /*#__PURE__*/React.createElement(Text, null, "We don't have anything here quite yet. Check back soon!")));
};